/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { BlankEnum } from './blankEnum';
import { CountryCodeEnum } from './countryCodeEnum';

export type ServiceAreaLocationCountryCode =
  (typeof ServiceAreaLocationCountryCode)[keyof typeof ServiceAreaLocationCountryCode];

export const ServiceAreaLocationCountryCode = { ...CountryCodeEnum, ...BlankEnum } as const;
